import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function getBranchOfficesGroup(query) {
    try {
        const data = await axios.get(`${REACT_APP_API}/groups/branchOffices${query}`)
        return data.data
    } catch (error) {
        throw new Error(error)
    }
}